import PropTypes from 'prop-types';

var propTypes = {
    isOpen: PropTypes.bool.isRequired,
    applicationName: PropTypes.string.isRequired,
    applicationButtonName: PropTypes.string,
    applicationLinks: PropTypes.arrayOf(PropTypes.object).isRequired,
    onOpenVerticalsMenu: PropTypes.func.isRequired,
    onSelectLink: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    className: PropTypes.string,
    withHeader: PropTypes.bool,
    'data-testid': PropTypes.string,
};
var defaultProps = {
    isOpenApplicationMenu: true,
    applicationName: 'WARN: APPLICATION NAME',
    applicationLinks: [],
    withHeader: false,
    'data-testid': 'left-nav-app-menu-component',
};

export { defaultProps, propTypes };
